<section class="volvo">
    <div class="tabMobSidePadding">
        <volvo-allservices-page></volvo-allservices-page>
        <div class="marginB16">
            <h2 class="pageHeading-h2Heading marginB8">
                {{ "uk/components/footer/volvoconnect" | lowercase | translate }}
            </h2>
            <h3 class="pageHeading-h3Heading marginB16">
                {{ "uk/pages/services/volvoconnect/title" | lowercase | translate }}
            </h3>
            <p class="volvo-text">
                {{"uk/pages/services/volvoconnect/text1" | lowercase | translate}}
            </p>
        </div>

        <div class="volvo-list marginB48">
            <div *ngFor="let list of volvoConnectList">
                <div class="volvo-list-contractDisplay">
                    <div class="marginB8">
                        <div
                            class="volvo-list-title-tractor">
                            <img [src]="list.url"
                                alt="{{ 'uk/pages/services/Financing/title1' | lowercase | translate }}" />
                        </div>
                    </div>
                    <div class="volvo-list-contractDisplay-padding spanMaxWidth">
                        <p class="volvo-list-title marginB8">{{ list.title | lowercase | translate }}</p>
                        <p class="volvo-text" [innerHTML]="list.text| translate"></p>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="volvo-img__wrap marginB48">
            <img [src]="assetService.getAssetUrl('assets/pages/services/volvo-connect-truck.webp')"
                class="volvo-img__width marginB16" alt="" />
            <div class="volvo-buttonDisplay">
                <div class="volvo-list-listItem">
                    <p class="volvo-list-title marginB8">{{ "pages/services/volvoconnect/supporttitle1" | lowercase | translate }}</p>
                    <p class="volvo-text">{{ "pages/services/volvoconnect/supporttext1" | lowercase | translate }}</p>
                </div>
                <div class="volvo-list-listItem">
                    <p class="volvo-list-title marginB8">{{ "pages/services/volvoconnect/supporttitle2" | lowercase | translate }}</p>
                    <p class="volvo-text">
                        {{ "pages/services/volvoconnect/supporttext2" | lowercase | translate }}
                        {{ "pages/services/volvoconnect/supporttext3" | lowercase | translate }}
                    </p>
                    

                </div>
            </div>
            <!-- <p class="volvo-img__description"
                [innerHTML]=" 'uk/pages/services/volvoconnect/hoverText' | lowercase | translate">
            </p>
            <p class="volvo-displayMobile"
                [innerHTML]=" 'uk/pages/services/volvoconnect/hoverText' | lowercase | translate">
            </p> -->
        </div>
        <h3 class="pageHeading-h3Heading marginB16">
            {{ "uk/pages/services/volvoconnect/text2" | lowercase | translate }}
        </h3>
        <div class="volvo-list volvo-list-connectList volvo-display">
            <div *ngFor="let list of volvoConnectImgList;let i=index;">
                <div class="volvo-list-listItem volvo-marginRight30 marginB32" *ngIf="i===0 || i===2">
                    <div class="marginB8">
                        <img [src]="list.url" class="volvo-list-connectList-connectImage"
                            alt="{{ list.title | lowercase | translate }}" />
                    </div>
                    <p class="volvo-list-title marginB8">
                        {{ list.title | translate }}
                    </p>
                    <p class="volvo-list-text" [innerHTML]="list.text| translate"></p>
                </div>
                <div class="volvo-list-listItem" *ngIf="i===1 || i===3">
                    <div class="marginB8">
                        <img [src]="list.url" class="volvo-list-connectList-connectImage"
                            alt="{{ list.title | lowercase | translate }}" />
                    </div>
                    <p class="volvo-list-title marginB8">
                        {{ list.title | translate }}
                    </p>
                    <p class="volvo-list-text" [innerHTML]="list.text| translate"></p>
                </div>
            </div>
        </div>
        <div class="volvo-list volvo-displayForMobile marginB48">
            <drag-scroll #sliderConnet (indexChanged)="onIndexChanged($event)">
                <div drag-scroll-item *ngFor="let list of volvoConnectImgList; let i = index"
                    class="volvo-dragScroll" scrollbar-hidden="true">
                    <div class="volvo-list-listItem">
                        <div>
                            <img [src]="list.url" alt="{{ list.title | lowercase | translate }}" />
                        </div>
                        <p class="volvo-list-title">
                            {{ list.title | translate }}
                        </p>
                        <p class="volvo-list-text" [innerHTML]="list.text| translate"></p>
                    </div>
                </div>
            </drag-scroll>
            <!-- Pagination Circle Buttons -->
            <div class="volvo-buttondiv">
            <button *ngFor="let item of volvoConnectImgList; let i = index"
                    (click)="sliderConnet.moveTo(i)"
                    class="volvo-dragscroll">
                <i class="fa fa-circle"
                [ngClass]="selectedIndex === i ? 'volvo-dragscroll-grey4' : 'volvo-dragscroll-grey1'">
                </i>
            </button>
            </div>
        </div>
        <h3 class="pageHeading-h3Heading marginB8">
            {{ "uk/pages/services/volvoconnect/text3" | lowercase | translate }}
        </h3>
        <div class="volvo-text3">
            <volvo-sales-person [salesTeamData]="salesTeamMangementDetails"></volvo-sales-person>
        </div>
    </div>
</section>
<!-- <volvo-footer class="footer"> -->